import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'
import { ContainerProvider } from '../../containerContext'
import { useApi, useLoading } from '../../../hooks'
import EstimateDetail from './EstimateDetail'

const Index = () => {
	const queryClient = useQueryClient()
  const [state, setState] = useState()
	const { id } = useParams()
	const { estimateService } = useApi()

	const closeModalPhoto = () => {
		setState(prev => {
			return { ...prev, vehicle: null, showModalPhoto: false }
		})
	}

	const showPhotoModal = (vehicle = {}) => {
		setState(prev => {
			return { ...prev, vehicle, showModalPhoto: true }
		})
	}

	const { isLoading, isSuccess, data = []} = useQuery('estimatesDetail',() => {
		return estimateService.get(id)
	})

	useEffect(() => {
		return () => {
			queryClient.removeQueries(['estimatesDetail'])
		}
	}, [queryClient])

	useLoading(isLoading)
	return (
		<ContainerProvider
			state={state}
			setState={setState}
			data={data.estimate || []}
			closeModalPhoto={closeModalPhoto}
			showPhotoModal={showPhotoModal}
		>
		  {isSuccess && <EstimateDetail />}
		</ContainerProvider>
	)
}

export default Index
